/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $OfferSignatureApple = {
    properties: {
        signature: {
            type: 'string',
            isRequired: true,
        },
        keyIdentifier: {
            type: 'string',
            isRequired: true,
        },
        timestamp: {
            type: 'number',
            isRequired: true,
        },
        nonce: {
            type: 'string',
            isRequired: true,
            format: 'uuid4',
        },
    },
} as const;
